<template>
  <div class="authorization-page">
    <RouterView></RouterView>
  </div>
</template>